import usePageNavigation from 'global/cnr/contexts/useHelpers/usePageNavigation'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import _ from 'lodash'
import { useContext } from 'react'
import { Label } from 'semantic-ui-react'
import FullPageWrapper from '../../../../global/wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper'
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext'

const TeamList = (props) => {

  const { contentOnly } = props

  const upn = usePageNavigation()

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { teams_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}

  const handleCancel = () => {
    sportsSeason_handlers.handleShow_sportsElem()
    if (props.handleCancel) {
      props.handleCancel()
    }
  }

  const handleClick = (team) => {
    sportsSeason_handlers.handleShow_sportsElem()
    if (props.handleSelect) {
      props.handleSelect(team)
    } else {
      team && upn.handleNav_item({ key: 'teams' }, team?._itemKey || team?.id)
    }
  }

  const fnAltContent = (item) => {
    const { levels, sections } = item ?? {}
    const _section = sections.replace('section', '')
    return <Label size='tiny'>{`${levels}/${_section}`}</Label>
  }

  const ims = (sz, caption) => <ItemMenuSquares
    menuItems={sz}
    onClick={handleClick}
    caption={caption}
    icon={'list'}
    iconItem={'users'}
    imsType={_imsTypes.dropdown}
    fn_altContent={fnAltContent}
  />

  const ims_teams = () => {
    const grouped = _.mapValues(
      _.groupBy(teams, (t) => _.toUpper(_.first(t.name))),
      (group) => _.sortBy(group, 'name')
    );
    const imsz = _.map(
      _.sortBy(_.keys(grouped)),
      (gk) => ims(grouped[gk], gk)
    );
    return <Wrapper
      content={imsz}
      wrapperType={wrapperTypes.padded}
      noMid={contentOnly}
    >
    </Wrapper>
  }

  const wrapper = () => <Wrapper
    content={ims_teams()}
    wrapperType={wrapperTypes.padded}
    noMid={contentOnly}
    css={{ container: 'app-dark-mode' }}
  />

  const fpw_teamList = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={'Team Lookup'}
  ></FullPageWrapper>

  return contentOnly ? wrapper() : fpw_teamList()
}

export default TeamList